export const xpParcer = (xp: number) => {
	return xp.toLocaleString("en-US", {
		maximumFractionDigits: 0,
	});
};
